'use strict';

// WIKI: https://wiki.sankuai.com/pages/viewpage.action?pageId=841284934
export const defaultDetail = {
    loading: true, // TODO: 动画
    isError: false, // TODO: 出错提示
    msg: '出错啦',
}

export const defaultNav = {
    staticData: [{
            id: 'detail',
            name: '活动详情'
        },
        {
            id: 'res',
            name: '活动回应'
        }
    ],
    navCursor: 'detail' //defaultNav.staticData[0].id
}

export const defaultResponse = {
    list: [],
    loading: false,
    page: 0,
    isEnd: false,
    isError: false,
    endMsg: '到底了',
    errMsg: '出错了'
}

export const defaultUser = {
    list: [],
    loading: false,
    page: 0,
    isEnd: false,
    isError: false,
    endMsg: '到底了',
    errMsg: '出错了'
}


// WEBPACK FOOTER //
// ./src/redux/init-state/detail.js